import { render } from "./CourseCard2.vue?vue&type=template&id=4b5f6794&scoped=true"
import script from "./CourseCard2.vue?vue&type=script&lang=js"
export * from "./CourseCard2.vue?vue&type=script&lang=js"

import "./CourseCard2.vue?vue&type=style&index=0&id=4b5f6794&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5f6794"]])

export default __exports__